import { useParams } from "react-router-dom";
import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  Box,
} from "@mui/material";

//Common styles
import {
  WorkspaceContainer,
  TabsContainer,
} from "../../styles/commonStyles";

//Components
import VisitTrackerMetaShow from "./VisitTrackerMetaShow";



const VisitTrackerShow = () => {
  const { entityType, visitId, cookid } = useParams();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }

  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`visit-tracker-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  }

  return (
    <WorkspaceContainer>
      <TabsContainer>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Visit tracker tabs"
        >
          <Tab label="Visit Tracker" {...a11yProps(0)} />
        </Tabs>
      </TabsContainer>
      <br />

      <CustomTabPanel value={value} index={0}>
        <VisitTrackerMetaShow 
            entityType={entityType}
            visitId={visitId}
            cookId={cookid}
        />
      </CustomTabPanel>
    </WorkspaceContainer>
  );
};



export default VisitTrackerShow;
